import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-4 md:space-y-0 md:flex-row items-start md:items-center px-5 md:justify-between" }

import { BaseCard } from '@/lib/components/Card';
import { MedKitButton } from '@bigpicturemedical/medkit';
import TouchpointSubHeader from './TouchpointSubHeader.vue';
import TouchpointHeader from './TouchpointHeader.vue';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewTouchpoint',
  props: {
    id: null,
    pathwayName: null,
    status: null,
    start: null,
    reviewedBy: null,
    managementPlanLabel: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
  pathwayName: string;
  status: { name: string };
  start: string;
  reviewedBy?: string;
  managementPlanLabel?: string;

};



const { t, d } = useI18n();

const headerItems = computed(() => [
  {
    label: t('custom.uhb.pathways.reviewed-date'),
    value: d(props.start, 'shortMonth')
  },
  {
    label: t('custom.uhb.pathways.reviewed-by'),
    value: props.reviewedBy
  },
  {
    label: t('custom.uhb.pathways.remote-monitoring-management-plan'),
    value: props.managementPlanLabel
  }
]);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseCard), {
    padding: "2",
    class: "px-0 py-4 mt-2"
  }, {
    default: _withCtx(() => [
      _createVNode(TouchpointHeader, {
        title: _unref(t)('custom.uhb.pathways.review'),
        pathway: __props.pathwayName,
        status: __props.status?.name
      }, null, 8, ["title", "pathway", "status"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(TouchpointSubHeader, { items: _unref(headerItems) }, null, 8, ["items"]),
        _createVNode(_unref(MedKitButton), {
          label: _unref(t)('custom.uhb.pathways.view-patient-letter'),
          kind: "secondary",
          size: "medium",
          class: "whitespace-no-wrap"
        }, null, 8, ["label"])
      ])
    ]),
    _: 1
  }))
}
}

})